import { Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const Errors = () => {
  const { t } = useTranslation();
  return (
    <Box display={"none"}>
      {t("zz_AgentApiErrorCode_PlannerProviderError")}
      {t("zz_AgentApiErrorCode_RequestTooLarge")}
      {t("zz_AgentApiErrorCode_UnknownModel")}
      {t("zz_AgentApiErrorCode_AiNotAllowedForOrganization")}
      {t("zz_AgentApiErrorCode_ToolModuleNotIncluded")}
      {t("zz_AgentApiErrorCode_ConversationFileTypeNotSupported")}
      {t("zz_AgentApiErrorCode_ConversationFileTooLarge")}
      {t("zz_AgentApiErrorCode_ConversationFileNotFound")}
      {t("zz_AgentApiErrorCode_ConversationFilesNotAllowedByAiSetting")}
      {t("zz_AgentApiErrorCode_ConversationFileReadOnlyAsAttachment")}
      {t("zz_AgentApiErrorCode_ArchiveSearchNotIncluded")}
      {t("zz_AgentApiErrorCode_ContentFiltered")}
      {t("zz_BidApiErrorCode_Unknown")}
      {t("zz_BidApiErrorCode_InvalidBidId")}
      {t("zz_BidApiErrorCode_InvalidSourcingEventId")}
      {t("zz_BidApiErrorCode_InvalidOrganizationId")}
      {t("zz_BidApiErrorCode_BidAlreadyDelivered")}
      {t("zz_BidApiErrorCode_CannotRejectBidReplacedByLaterBid")}
      {t("zz_BidApiErrorCode_CannotDeliverBidWhenDeadlineHasPassed")}
      {t("zz_BidApiErrorCode_EventNotFound")}
      {t("zz_BidApiErrorCode_InvalidDocumentId")}
      {t("zz_BidApiErrorCode_BidNotEditable")}
      {t("zz_BidApiErrorCode_BidLockedByDeadline")}
      {t("zz_BidApiErrorCode_BidNotFound")}
      {t("zz_BidApiErrorCode_NegotiationRoundNotFound")}
      {t("zz_BidApiErrorCode_BidNotReadyForSigning")}
      {t("zz_BidApiErrorCode_CannotRejectBidThatIsNotSubmitted")}
      {t("zz_BidApiErrorCode_SignedDocumentMissing")}
      {t("zz_BidApiErrorCode_SigningNotCompleted")}
      {t("zz_BidApiErrorCode_NoSigningInProgress")}
      {t("zz_BidApiErrorCode_SignicatCancelFailed")}
      {t("zz_BidApiErrorCode_EspdResponseInvalid")}
      {t("zz_BidApiErrorCode_SigningProviderUnavailable")}
      {t("zz_BidApiErrorCode_NoTermsDefined")}
      {t("zz_BidApiErrorCode_TermsNotAccepted")}
      {t("zz_BidApiErrorCode_PriceNotInTenderCurrency")}
      {t("zz_BidApiErrorCode_QualificationClosed")}
      {t("zz_BidApiErrorCode_RejectionLockedByAwardDecision")}
      {t("zz_BidApiErrorCode_QualificationReviewIncomplete")}
      {t("zz_BidApiErrorCode_MinimumRequirementResponseIncomplete")}
      {t("zz_BidApiErrorCode_CannotRevokeRejectionOfBidThatIsNotRejected")}
      {t("zz_BidApiErrorCode_RevokeRejectionReasonRequired")}
      {t("zz_BidApiErrorCode_RevokeRejectionReasonTooLong")}
      {t("zz_BidApiErrorCode_ContributingEntityNotFound")}
      {t("zz_BidApiErrorCode_ContributingEntityInviteNotFound")}
      {t("zz_BidApiErrorCode_ContributingEntityInviteAlreadyAccepted")}
      {t("zz_BidApiErrorCode_ContributingEntityInviteRateLimited")}
      {t("zz_BidApiErrorCode_ContributingEntityDuplicateOrgNumber")}
      {t("zz_BidApiErrorCode_ContributingEntityInvitationDeclined")}
      {t("zz_BidApiErrorCode_ContributingEntityBoundToAnotherOrganization")}
      {t("zz_BidApiErrorCode_ContributingEntityResponseNotEditable")}
      {t("zz_BidApiErrorCode_ContributingEntityResponseNotSubmitted")}
      {t("zz_BidApiErrorCode_ContributingEntityNameRequired")}
      {t("zz_BidApiErrorCode_ContributingEntityEmailInvalid")}
      {t("zz_BidApiErrorCode_ContributingEntityOrgNumberInvalid")}
      {t("zz_BidApiErrorCode_ContributingEntityGroupRoleRequired")}
      {t("zz_BidApiErrorCode_ContributingEntityCommitmentNotApplicable")}
      {t("zz_BidApiErrorCode_ContributingEntityAcceptingOrgMismatch")}
      {t("zz_BidApiErrorCode_ContributingEntityAcceptingPersonMismatch")}
      {t("zz_BidApiErrorCode_NoStandingBidToConfirm")}
      {t("zz_ContractApiErrorCode_Unknown")}
      {t("zz_ContractApiErrorCode_CustomFieldNotFound")}
      {t("zz_ContractApiErrorCode_CustomFieldCannotFilterSuppliers")}
      {t("zz_ContractApiErrorCode_ContractListTooLargeToDownload")}
      {t("zz_ContractApiErrorCode_TaskListTooLargeToDownload")}
      {t("zz_ContractApiErrorCode_SourcingEventHasNoDepartment")}
      {t("zz_ContractApiErrorCode_HomeDepartmentNotInOrganization")}
      {t("zz_ContractApiErrorCode_ContractNotFound")}
      {t("zz_ContractApiErrorCode_ContractDocumentNotFound")}
      {t("zz_ContractApiErrorCode_DocumentToRemoveNotFound")}
      {t("zz_ContractApiErrorCode_MainDocumentMustBePdf")}
      {t("zz_ContractApiErrorCode_DataFieldNotFound")}
      {t("zz_ContractApiErrorCode_TemplateNotFound")}
      {t("zz_ContractApiErrorCode_TaskNotFound")}
      {t("zz_ContractApiErrorCode_TemplateNameCannotBeEmpty")}
      {t("zz_ContractApiErrorCode_CouldNotFindNewOrganization")}
      {t("zz_ContractApiErrorCode_CouldNotFindNewPerson")}
      {t("zz_ContractApiErrorCode_CouldNotFindOldOrganization")}
      {t("zz_ContractApiErrorCode_CouldNotFindOldPerson")}
      {t("zz_ContractApiErrorCode_ParticipantNotFound")}
      {t("zz_ContractApiErrorCode_DataFieldNotAdded")}
      {t("zz_ContractApiErrorCode_CounterpartyOrganizationEntryNotFound")}
      {t("zz_ContractApiErrorCode_CounterpartyIsSetByTheFrameworkAgreement")}
      {t("zz_ContractApiErrorCode_CurrencyIsSetByTheFrameworkAgreement")}
      {t("zz_ContractApiErrorCode_CounterpartyOrganizationNotFound")}
      {t("zz_ContractApiErrorCode_IndustryNotFound")}
      {t("zz_ContractApiErrorCode_LinkedContractsIsSameAsContractBeingUpdated")}
      {t("zz_ContractApiErrorCode_LinkedContractsNotFound")}
      {t("zz_ContractApiErrorCode_NotificationReceiverNotFound")}
      {t("zz_ContractApiErrorCode_OriginSourcingEventNotFound")}
      {t("zz_ContractApiErrorCode_OwningOrganizationCanNotBeCounterparty")}
      {t("zz_ContractApiErrorCode_InternalOwnerNotFound")}
      {t("zz_ContractApiErrorCode_OrganizationNotFound")}
      {t("zz_ContractApiErrorCode_PersonNotFound")}
      {t("zz_ContractApiErrorCode_InvalidResponsibleOrg")}
      {t("zz_ContractApiErrorCode_InvalidResponsiblePerson")}
      {t("zz_ContractApiErrorCode_CanNotAddOwnerAsParticipant")}
      {t("zz_ContractApiErrorCode_TooManyNotifications")}
      {t("zz_ContractApiErrorCode_CanOnlyUpdateNotificationsInPublishedState")}
      {t("zz_ContractApiErrorCode_CanOnlyUpdateParticipantsInPublishedState")}
      {t("zz_ContractApiErrorCode_CanOnlyUpdateTasksInPublishedState")}
      {t("zz_ContractApiErrorCode_CannotBothHaveExpirationDateAndNoExpirationDate")}
      {t("zz_ContractApiErrorCode_CannotGetTextOfDeletedComment")}
      {t("zz_ContractApiErrorCode_CannotPublishWithoutCounterparty")}
      {t("zz_ContractApiErrorCode_CommentNotFound")}
      {t("zz_ContractApiErrorCode_ContractDoesNotHaveTemplate")}
      {t("zz_ContractApiErrorCode_ContractIsAlreadyPublished")}
      {t("zz_ContractApiErrorCode_InvalidAmountInNotificationConfig")}
      {t("zz_ContractApiErrorCode_InvalidTemplateName")}
      {t("zz_ContractApiErrorCode_NewOrganizationDoesNotMatch")}
      {t("zz_ContractApiErrorCode_NewPersonDoesNotMatch")}
      {t("zz_ContractApiErrorCode_NotificationHasAlreadyBeenSentForThisDate")}
      {t("zz_ContractApiErrorCode_NotificationNotFound")}
      {t("zz_ContractApiErrorCode_OldOrganizationDoesNotMatch")}
      {t("zz_ContractApiErrorCode_OldPersonDoesNotMatch")}
      {t("zz_ContractApiErrorCode_SignatureAlreadyProvidedForSigner")}
      {t("zz_ContractApiErrorCode_SignedDocumentNotFound")}
      {t("zz_ContractApiErrorCode_TemplateDoesNotMatchContract")}
      {t("zz_ContractApiErrorCode_TooManyDaysForNotificationConfig")}
      {t("zz_ContractApiErrorCode_TooManyMonthsForNotificationConfig")}
      {t("zz_ContractApiErrorCode_InvalidResponsibleParty")}
      {t("zz_ContractApiErrorCode_ResponsiblePersonCannotViewContract")}
      {t("zz_ContractApiErrorCode_TerminationDateAlreadySet")}
      {t("zz_ContractApiErrorCode_AllReceiversAreNotParticipants")}
      {t("zz_ContractApiErrorCode_DepartmentNotFound")}
      {t("zz_ContractApiErrorCode_CouldNotUpdateContractPermission")}
      {t("zz_ContractApiErrorCode_CannotCreateContracts")}
      {t("zz_ContractApiErrorCode_OptionAlreadyExecuted")}
      {t("zz_ContractApiErrorCode_OptionNotFound")}
      {t("zz_ContractApiErrorCode_OptionLocked")}
      {t("zz_ContractApiErrorCode_EarlierOptionUndecided")}
      {t("zz_ContractApiErrorCode_OptionDeadlineBeforeContractStart")}
      {t("zz_ContractApiErrorCode_ExtensionsOverlap")}
      {t("zz_ContractApiErrorCode_OptionWouldLapse")}
      {t("zz_ContractApiErrorCode_OptionPeriodRequired")}
      {t("zz_ContractApiErrorCode_InvalidOptionExtension")}
      {t("zz_ContractApiErrorCode_OptionEndBeforeStart")}
      {t("zz_ContractApiErrorCode_OptionDeadlineAfterStart")}
      {t("zz_ContractApiErrorCode_OptionDoesNotExtendContract")}
      {t("zz_ContractApiErrorCode_EndDateBeforeExercisedExtension")}
      {t("zz_ContractApiErrorCode_EndDatePastNextExtension")}
      {t("zz_ContractApiErrorCode_OptionChangedElsewhere")}
      {t("zz_ContractApiErrorCode_AttachmentNotFound")}
      {t("zz_ContractApiErrorCode_NoMainDocumentProvided")}
      {t("zz_ContractApiErrorCode_InvalidLimit")}
      {t("zz_ContractApiErrorCode_InvalidTimeZone")}
      {t("zz_ContractApiErrorCode_AmountMustBeWholeNumber")}
      {t("zz_ContractApiErrorCode_EstimatedValueMustNotBeNegative")}
      {t("zz_ContractApiErrorCode_TotalPriceMustNotBeNegative")}
      {t("zz_ContractApiErrorCode_InvalidDate")}
      {t("zz_ContractApiErrorCode_InvalidSigningDeadline")}
      {t("zz_ContractApiErrorCode_InvalidNoticePeriodDuration")}
      {t("zz_ContractApiErrorCode_EmbeddedImagesNotReady")}
      {t("zz_ContractApiErrorCode_SelectedDocumentNotAvailable")}
      {t("zz_ContractApiErrorCode_SigningDocumentCannotBePrepared")}
      {t("zz_ContractApiErrorCode_SignedDocumentNotExpired")}
      {t("zz_ContractApiErrorCode_SignedDocumentNotOpenForSigning")}
      {t("zz_ContractApiErrorCode_SigningMessageTooLong")}
      {t("zz_ContractApiErrorCode_IfrsValuesMissing")}
      {t("zz_ContractApiErrorCode_InvalidIfrsReportPeriod")}
      {t("zz_ContractApiErrorCode_NoIfrsContractInPeriod")}
      {t("zz_DocumentApiErrorCode_FencyApiError")}
      {t("zz_DocumentApiErrorCode_FencyMemoryNotReady")}
      {t("zz_DocumentApiErrorCode_NoDocumentsProvided")}
      {t("zz_DocumentApiErrorCode_NoFencyMemoriesExistForDocuments")}
      {t("zz_DocumentApiErrorCode_InvalidDocumentId")}
      {t("zz_DocumentApiErrorCode_DocumentNotFound")}
      {t("zz_DocumentApiErrorCode_Unknown")}
      {t("zz_DocumentApiErrorCode_AttachmentNotFound")}
      {t("zz_DocumentApiErrorCode_AttachmentNoLongerOnNeed")}
      {t("zz_DocumentApiErrorCode_RateLimitExceeded")}
      {t("zz_DocumentApiErrorCode_UnknownChatError")}
      {t("zz_DocumentApiErrorCode_ContextLengthExceeded")}
      {t("zz_DocumentApiErrorCode_FailedToDownloadDocument")}
      {t("zz_DocumentApiErrorCode_FailedToDownloadSignedDocument")}
      {t("zz_DocumentApiErrorCode_FailedToLoadDocument")}
      {t("zz_DocumentApiErrorCode_FailedToGetTextFromDocument")}
      {t("zz_DocumentApiErrorCode_UnsupportedDocumentFormat")}
      {t("zz_DocumentApiErrorCode_DocumentPasswordProtected")}
      {t("zz_DocumentApiErrorCode_DocumentScanned")}
      {t("zz_DocumentApiErrorCode_DocumentHasNoText")}
      {t("zz_DocumentApiErrorCode_DocumentTooLong")}
      {t("zz_DocumentApiErrorCode_DocumentUnreadable")}
      {t("zz_DocumentApiErrorCode_SigningRequestStillOpen")}
      {t("zz_DocumentApiErrorCode_SigningRequestSignedAtSignicat")}
      {t("zz_DocumentApiErrorCode_SigningServiceUnreachable")}
      {t("zz_EmailInviteApiErrorCode_Unknown")}
      {t("zz_EmailInviteApiErrorCode_InvalidInviteId")}
      {t("zz_EmailInviteApiErrorCode_CannotAcceptAlreadyAcceptedInvite")}
      {t("zz_EmailInviteApiErrorCode_InvalidEmail")}
      {t("zz_EmailInviteApiErrorCode_InvalidOrganizationId")}
      {t("zz_EmailInviteApiErrorCode_CannotDeleteAlreadyAcceptedInvite")}
      {t("zz_EmailInviteApiErrorCode_SecretNotMatching")}
      {t("zz_EmailInviteApiErrorCode_CannotSendReminderForUnPublishedSourcingEvent")}
      {t("zz_EmailInviteApiErrorCode_OrgUserEmailInviteAlreadyAccepted")}
      {t("zz_EmailInviteApiErrorCode_SourcingEventEmailInviteAlreadyAccepted")}
      {t("zz_EmailInviteApiErrorCode_SupplierEmailInviteAlreadyAccepted")}
      {t("zz_EmailInviteApiErrorCode_InviteIsForAnotherOrganization")}
      {t("zz_EmailInviteApiErrorCode_InviteeOwnsTheEvent")}
      {t("zz_EmailInviteApiErrorCode_InviteeIsTheFrameworkBuyer")}
      {t("zz_OrganizationApiErrorCode_Unknown")}
      {t("zz_OrganizationApiErrorCode_InvalidAdminEmails")}
      {t("zz_OrganizationApiErrorCode_InvalidOrganizationId")}
      {t("zz_OrganizationApiErrorCode_InvalidEmailInviteId")}
      {t("zz_OrganizationApiErrorCode_InvalidCountryId")}
      {t("zz_OrganizationApiErrorCode_OrgNameTooShort")}
      {t("zz_OrganizationApiErrorCode_CannotCreateOrganizationWithAlreadyAcceptedInvite")}
      {t("zz_OrganizationApiErrorCode_InvalidSourcingEventId")}
      {t("zz_OrganizationApiErrorCode_EmailInviteSecretNotMatching")}
      {t("zz_OrganizationApiErrorCode_EmailInviteIsForAnotherOrganization")}
      {t("zz_OrganizationApiErrorCode_EmailInviteRateLimited")}
      {t("zz_OrganizationApiErrorCode_NotAllowedToCreateOrganization")}
      {t("zz_OrganizationApiErrorCode_CannotCreateOrgWhenAlreadyOrganizationOwner")}
      {t("zz_OrganizationApiErrorCode_CannotChangeRoleForOrgOwner")}
      {t("zz_OrganizationApiErrorCode_CannotChangeRoleToOwner")}
      {t("zz_OrganizationApiErrorCode_ExistingPersonNotFound")}
      {t("zz_OrganizationApiErrorCode_InvalidPersonId")}
      {t("zz_OrganizationApiErrorCode_AlreadyLinked")}
      {t("zz_OrganizationApiErrorCode_EntryNotFound")}
      {t("zz_OrganizationApiErrorCode_OrganizationNotFound")}
      {t("zz_OrganizationApiErrorCode_NotAllowedToGenerateToken")}
      {t("zz_OrganizationApiErrorCode_OrgNumberAlreadyUsed")}
      {t("zz_OrganizationApiErrorCode_OrgNumberRequiredForNorwegianOrg")}
      {t("zz_OrganizationApiErrorCode_OrgNumberInvalidFormat")}
      {t("zz_OrganizationApiErrorCode_OrgNumberNotInBrreg")}
      {t("zz_OrganizationApiErrorCode_OrgNumberInactiveInBrreg")}
      {t("zz_OrganizationApiErrorCode_BrregUnavailable")}
      {t("zz_OrganizationApiErrorCode_IdentityProviderUnavailable")}
      {t("zz_OrganizationApiErrorCode_ApiClientNotCreated")}
      {t("zz_OrganizationApiErrorCode_OrgNameAlreadyUsed")}
      {t("zz_OrganizationApiErrorCode_InvalidSearchParams")}
      {t("zz_OrganizationApiErrorCode_ServicePrincipalsHaveNoOrgContext")}
      {t("zz_OrganizationApiErrorCode_Forbidden")}
      {t("zz_OrganizationApiErrorCode_ContactPersonNotFound")}
      {t("zz_OrganizationApiErrorCode_ContactPersonAlreadyExists")}
      {t("zz_OrganizationApiErrorCode_InvalidLimit")}
      {t("zz_OrganizationApiErrorCode_NewOwnerIsAlreadyOwner")}
      {t("zz_OrganizationApiErrorCode_NewOwnerNotMemberOfOrganization")}
      {t("zz_OrganizationApiErrorCode_NewOwnerAlreadyOwnsAnotherOrganization")}
      {t("zz_OrganizationApiErrorCode_DepartmentNotFound")}
      {t("zz_OrganizationApiErrorCode_RoleNotOfferedInDepartment")}
      {t("zz_OrganizationApiErrorCode_PersonNotInOrganization")}
      {t("zz_OrganizationApiErrorCode_DepartmentRoleAlreadyAssigned")}
      {t("zz_OrganizationApiErrorCode_DepartmentRoleNotFound")}
      {t("zz_OrganizationApiErrorCode_DepartmentNameIsBlank")}
      {t("zz_OrganizationApiErrorCode_DepartmentNameAlreadyUsed")}
      {t("zz_OrganizationApiErrorCode_CannotDeactivateDefaultDepartment")}
      {t("zz_OrganizationApiErrorCode_DepartmentIsInUse")}
      {t("zz_OrganizationApiErrorCode_AssessmentTemplateNotFound")}
      {t("zz_OrganizationApiErrorCode_AssessmentNotFound")}
      {t("zz_OrganizationApiErrorCode_InvalidAssessment")}
      {t("zz_OrganizationApiErrorCode_DirectoryManagedAccess")}
      {t("zz_OrganizationApiErrorCode_NotADuplicateOrganization")}
      {t("zz_OrganizationApiErrorCode_MergeRequestAlreadyPending")}
      {t("zz_OrganizationApiErrorCode_MergeRequestNotFound")}
      {t("zz_OrganizationApiErrorCode_MergeRequestNotForThisOrganization")}
      {t("zz_OrganizationApiErrorCode_MergeRequestNotPending")}
      {t("zz_OrganizationApiErrorCode_MergeRequestExpired")}
      {t("zz_OrganizationApiErrorCode_MergeRequestCancelled")}
      {t("zz_OrganizationApiErrorCode_MergeCompetitionInProgress")}
      {t("zz_OrganizationApiErrorCode_MergeInvitedToCompetitionInProgress")}
      {t("zz_OrganizationApiErrorCode_MergeLosingOrganizationUsesEntraId")}
      {t("zz_OrganizationApiErrorCode_PanelSupplierIsTheBuyer")}
      {t("zz_OrganizationApiErrorCode_InvalidAiFairUse")}
      {t("zz_OrganizationApiErrorCode_InvalidFrameworkValueReminderPercentage")}
      {t("zz_OrganizationApiErrorCode_FrameworkValueReminderWithoutReceivers")}
      {t("zz_OrganizationApiErrorCode_FrameworkValueReminderReceiverOutsideTheOrganization")}
      {t("zz_OrganizationApiErrorCode_AiNeedsBuyerOrContractAccess")}
      {t("zz_OrganizationApiErrorCode_AiSkillAlreadyIncluded")}
      {t("zz_OrganizationApiErrorCode_UnknownAiSkill")}
      {t("zz_OrganizationApiErrorCode_AuditLogPeriodEndsBeforeItStarts")}
      {t("zz_OrganizationApiErrorCode_AuditLogPositionNotRecognised")}
      {t("zz_OrganizationApiErrorCode_AuditLogPageSizeOutOfRange")}
      {t("zz_OrganizationApiErrorCode_AuditLogTooLargeToDownload")}
      {t("zz_PersonApiErrorCode_Unknown")}
      {t("zz_PersonApiErrorCode_PersonNotFound")}
      {t("zz_PersonApiErrorCode_DuplicateEmail")}
      {t("zz_PersonApiErrorCode_Forbidden")}
      {t("zz_PersonApiErrorCode_NoOrgContextForAzureUser")}
      {t("zz_PersonApiErrorCode_OnlyAzureLoginAllowedForOrg")}
      {t("zz_PersonApiErrorCode_OrganizationIdRequired")}
      {t("zz_PersonApiErrorCode_SavedReportNameRequired")}
      {t("zz_PersonApiErrorCode_SavedReportNameTooLong")}
      {t("zz_PersonApiErrorCode_SavedReportQueryTooLong")}
      {t("zz_PersonApiErrorCode_SavedReportShareWithSelf")}
      {t("zz_PersonApiErrorCode_SavedReportRecipientNotInOrganization")}
      {t("zz_PersonApiErrorCode_SavedReportNotFound")}
      {t("zz_PersonApiErrorCode_SavedReportFirmReportCannotBeShared")}
      {t("zz_SourcingEventApiErrorCode_Unknown")}
      {t("zz_SourcingEventApiErrorCode_EventNotFound")}
      {t("zz_SourcingEventApiErrorCode_InterviewAlreadySaved")}
      {t("zz_SourcingEventApiErrorCode_InvalidSourcingEventId")}
      {t("zz_SourcingEventApiErrorCode_CannotDeliverRoundBidInCurrentState")}
      {t("zz_SourcingEventApiErrorCode_CannotAnswerRoundAfterDeadline")}
      {t("zz_SourcingEventApiErrorCode_CannotDeclineRoundWithDeliveredBid")}
      {t("zz_SourcingEventApiErrorCode_CannotAnswerDeclinedRound")}
      {t("zz_SourcingEventApiErrorCode_InvalidDeadline")}
      {t("zz_SourcingEventApiErrorCode_CannotPerformEditInAwardedState")}
      {t("zz_SourcingEventApiErrorCode_NotEditableInStatus")}
      {t("zz_SourcingEventApiErrorCode_InvalidDocumentId")}
      {t("zz_SourcingEventApiErrorCode_EmailInviteToAddAlreadyExists")}
      {t("zz_SourcingEventApiErrorCode_EmailInviteToBeRemovedNotFound")}
      {t("zz_SourcingEventApiErrorCode_OrganizationInviteNotFound")}
      {t("zz_SourcingEventApiErrorCode_OrganizationAlreadyInvited")}
      {t("zz_SourcingEventApiErrorCode_CannotInviteOwnOrganization")}
      {t("zz_SourcingEventApiErrorCode_CannotRemoveOrganizationThatHasDeliveredBid")}
      {t("zz_SourcingEventApiErrorCode_SupplierLeavesNegotiationOnlyByRejection")}
      {t("zz_SourcingEventApiErrorCode_RejectedSupplierCannotJoinRound")}
      {t("zz_SourcingEventApiErrorCode_ReducedSupplierCannotJoinRound")}
      {t("zz_SourcingEventApiErrorCode_ReductionReasonMissing")}
      {t("zz_SourcingEventApiErrorCode_ReductionOnlyBetweenRounds")}
      {t("zz_SourcingEventApiErrorCode_RejectedSupplierCannotDeliver")}
      {t("zz_SourcingEventApiErrorCode_ChangeRemovesCompanyThatCannotBeRemoved")}
      {t("zz_SourcingEventApiErrorCode_CannotRemoveInviteWhileBidsAreSealed")}
      {t("zz_SourcingEventApiErrorCode_LifecycleTransitionNotAllowed")}
      {t("zz_SourcingEventApiErrorCode_FinalNegotiationRoundExists")}
      {t("zz_SourcingEventApiErrorCode_ProcedureDoesNotAllowNegotiation")}
      {t("zz_SourcingEventApiErrorCode_NegotiationParticipantsNotSettled")}
      {t("zz_SourcingEventApiErrorCode_DialogueSelectionJustificationMissing")}
      {t("zz_SourcingEventApiErrorCode_DialogueDepartureJustificationMissing")}
      {t("zz_SourcingEventApiErrorCode_AwardDepartsFromBindingJury")}
      {t("zz_SourcingEventApiErrorCode_JuryDepartureJustificationMissing")}
      {t("zz_SourcingEventApiErrorCode_RankingDepartureJustificationMissing")}
      {t("zz_SourcingEventApiErrorCode_RankingDepartureNotApplicable")}
      {t("zz_SourcingEventApiErrorCode_FlaggedEntriesNotAcknowledged")}
      {t("zz_SourcingEventApiErrorCode_JuryMemberCanStillOpen")}
      {t("zz_SourcingEventApiErrorCode_CannotAwardWithOpenNegotiationRound")}
      {t("zz_SourcingEventApiErrorCode_CannotAwardUnscoredRoundTenders")}
      {t("zz_SourcingEventApiErrorCode_CannotAwardRestoredTenderNotEvaluated")}
      {t("zz_SourcingEventApiErrorCode_CannotAwardRestoredSupplierLeftOutOfRound")}
      {t("zz_SourcingEventApiErrorCode_CannotAwardWinnerExclusionGroundsNotAssessed")}
      {t("zz_SourcingEventApiErrorCode_CannotAwardBeforeJuryDecision")}
      {t("zz_SourcingEventApiErrorCode_CannotAwardReplacedTender")}
      {t("zz_SourcingEventApiErrorCode_CannotCompleteBeforeDeadline")}
      {t("zz_SourcingEventApiErrorCode_CannotCompleteBeforeBidDeadline")}
      {t("zz_SourcingEventApiErrorCode_OrganizationInviteAlreadyAccepted")}
      {t("zz_SourcingEventApiErrorCode_OrganizationNotInvited")}
      {t("zz_SourcingEventApiErrorCode_QuestionNotFound")}
      {t("zz_SourcingEventApiErrorCode_CannotPerformEditInCompletedState")}
      {t("zz_SourcingEventApiErrorCode_CannotSetSelectedProductBidsInCompletedState")}
      {t("zz_SourcingEventApiErrorCode_CannotCompleteInDraftState")}
      {t("zz_SourcingEventApiErrorCode_CannotOpenPublishedEvent")}
      {t("zz_SourcingEventApiErrorCode_FailedToGetProductGroups")}
      {t("zz_SourcingEventApiErrorCode_PersonsToInviteNotFound")}
      {t("zz_SourcingEventApiErrorCode_AllRecipientsAlreadyInvited")}
      {t("zz_SourcingEventApiErrorCode_OrganizationInviteAlreadyDeclined")}
      {t("zz_SourcingEventApiErrorCode_NegotiationRoundNotFound")}
      {t("zz_SourcingEventApiErrorCode_CanOnlyPublishNegotiationRoundsInDraftState")}
      {t("zz_SourcingEventApiErrorCode_CannotPublishNegotiationRoundWithPastDeadline")}
      {t("zz_SourcingEventApiErrorCode_CannotPublishNegotiationRoundWithoutInvites")}
      {t("zz_SourcingEventApiErrorCode_CannotOpenNegotiationRoundAfterEvaluationCompleted")}
      {t("zz_SourcingEventApiErrorCode_CanOnlyEditInviteMessageInDraftRound")}
      {t("zz_SourcingEventApiErrorCode_InvalidEventContext")}
      {t("zz_SourcingEventApiErrorCode_UnknownExclusionGroundId")}
      {t("zz_SourcingEventApiErrorCode_MissingMandatoryExclusionGround")}
      {t("zz_SourcingEventApiErrorCode_CannotAwardEventNotInEvaluation")}
      {t("zz_SourcingEventApiErrorCode_CannotConfirmAwardNotInAwardDecision")}
      {t("zz_SourcingEventApiErrorCode_CannotRevokeAwardNotInAwardDecision")}
      {t("zz_SourcingEventApiErrorCode_CannotReopenPublicAwardedEvent")}
      {t("zz_SourcingEventApiErrorCode_CannotReopenConcludedContract")}
      {t("zz_SourcingEventApiErrorCode_CannotCancelConcludedContract")}
      {t("zz_SourcingEventApiErrorCode_RevokeReasonRequired")}
      {t("zz_SourcingEventApiErrorCode_EventNotAwarded")}
      {t("zz_SourcingEventApiErrorCode_NoWinningBidSelected")}
      {t("zz_SourcingEventApiErrorCode_BidNotForEvent")}
      {t("zz_SourcingEventApiErrorCode_BidNotAwarded")}
      {t("zz_SourcingEventApiErrorCode_DocumentNotPartOfEvent")}
      {t("zz_SourcingEventApiErrorCode_DirectAwardNotAvailable")}
      {t("zz_SourcingEventApiErrorCode_DirectAwardSupplierNotFound")}
      {t("zz_SourcingEventApiErrorCode_IntentionNoticeNotYetPublished")}
      {t("zz_SourcingEventApiErrorCode_IntentionNoticeWaitRunning")}
      {t("zz_SourcingEventApiErrorCode_AwardLettersNotDispatched")}
      {t("zz_SourcingEventApiErrorCode_StandstillNotElapsed")}
      {t("zz_SourcingEventApiErrorCode_WinnerDocumentationNotChecked")}
      {t("zz_SourcingEventApiErrorCode_WinnerDocumentationEvidenceNotChecked")}
      {t("zz_SourcingEventApiErrorCode_WinnerDocumentationNoteTooLong")}
      {t("zz_SourcingEventApiErrorCode_RelativeAdvantagesTooLong")}
      {t("zz_SourcingEventApiErrorCode_ContractConcludedInFuture")}
      {t("zz_SourcingEventApiErrorCode_CancellationReasonCodeRequired")}
      {t("zz_SourcingEventApiErrorCode_CancellationReasonCodeNotYetDue")}
      {t("zz_SourcingEventApiErrorCode_CancellationReasonTooShort")}
      {t("zz_SourcingEventApiErrorCode_ProcurementListTooLargeToDownload")}
      {t("zz_SourcingEventApiErrorCode_ProcurementPlanTooLarge")}
      {t("zz_SourcingEventApiErrorCode_CancellationReasonMissing")}
      {t("zz_SourcingEventApiErrorCode_EventAlreadyCancelled")}
      {t("zz_SourcingEventApiErrorCode_PublishedQualificationSchemeEndsByNotice")}
      {t("zz_SourcingEventApiErrorCode_PublicProcurementEndsByCancelling")}
      {t("zz_SourcingEventApiErrorCode_MiniCompetitionEndsByCancelling")}
      {t("zz_SourcingEventApiErrorCode_ContractConcludedBeforeAward")}
      {t("zz_SourcingEventApiErrorCode_InjunctionAnswerRequired")}
      {t("zz_SourcingEventApiErrorCode_ContractSuspendedByInjunction")}
      {t("zz_SourcingEventApiErrorCode_ResultNoticeAlreadySent")}
      {t("zz_SourcingEventApiErrorCode_ResultNoticeRequired")}
      {t("zz_SourcingEventApiErrorCode_StandstillNotSetByBuyer")}
      {t("zz_SourcingEventApiErrorCode_StandstillDaysTooShort")}
      {t("zz_SourcingEventApiErrorCode_StandstillDaysTooLong")}
      {t("zz_SourcingEventApiErrorCode_MoreWinnersThanTheFrameworkAgreementAllows")}
      {t("zz_SourcingEventApiErrorCode_SpecialServicesStandstillTooShort")}
      {t("zz_SourcingEventApiErrorCode_PartIVStandstillTooShort")}
      {t("zz_SourcingEventApiErrorCode_UtilitiesPartIIIStandstillTooShort")}
      {t("zz_SourcingEventApiErrorCode_StandstillExemptionNotApplicable")}
      {t("zz_SourcingEventApiErrorCode_StandstillExemptionRequiresCallOff")}
      {t("zz_SourcingEventApiErrorCode_StandstillDaysAndExemptionBothSet")}
      {t("zz_SourcingEventApiErrorCode_CannotEvaluateEventNotInEvaluation")}
      {t("zz_SourcingEventApiErrorCode_CannotEvaluateRejectedBid")}
      {t("zz_SourcingEventApiErrorCode_BidDeliveredAgainWhileAssessing")}
      {t("zz_SourcingEventApiErrorCode_BidWithdrawnWhileAssessing")}
      {t("zz_SourcingEventApiErrorCode_CannotAwardRejectedTender")}
      {t("zz_SourcingEventApiErrorCode_BidDeliveredAgainWhileReviewing")}
      {t("zz_SourcingEventApiErrorCode_CannotScorePriceCriterion")}
      {t("zz_SourcingEventApiErrorCode_UnknownAwardCriterion")}
      {t("zz_SourcingEventApiErrorCode_InvalidScore")}
      {t("zz_SourcingEventApiErrorCode_InvalidPriceOverride")}
      {t("zz_SourcingEventApiErrorCode_CannotBeginEvaluationEventNotPublished")}
      {t("zz_SourcingEventApiErrorCode_NoTendersToQualify")}
      {t("zz_SourcingEventApiErrorCode_QualificationIncomplete")}
      {t("zz_SourcingEventApiErrorCode_EvaluationIncomplete")}
      {t("zz_SourcingEventApiErrorCode_AwardLettersNotFound")}
      {t("zz_SourcingEventApiErrorCode_AwardLetterNotFound")}
      {t("zz_SourcingEventApiErrorCode_AwardLetterLocked")}
      {t("zz_SourcingEventApiErrorCode_AwardLettersNotAllApproved")}
      {t("zz_SourcingEventApiErrorCode_AwardLettersAlreadyDispatched")}
      {t("zz_SourcingEventApiErrorCode_AwardLetterCriterionJustificationMissing")}
      {t("zz_SourcingEventApiErrorCode_AwardLetterCriterionJustificationTooLong")}
      {t("zz_SourcingEventApiErrorCode_AwardLetterFreeTextTooLong")}
      {t("zz_SourcingEventApiErrorCode_AwardLetterRankingDepartureExplanationTooLong")}
      {t("zz_SourcingEventApiErrorCode_AwardLetterRankingDepartureExplanationMissing")}
      {t("zz_SourcingEventApiErrorCode_AwardLetterReasonForTheChoiceMissing")}
      {t("zz_SourcingEventApiErrorCode_AwardLetterChosenTenderAdvantagesMissing")}
      {t("zz_SourcingEventApiErrorCode_QuestionDeadlineHasPassed")}
      {t("zz_SourcingEventApiErrorCode_ResponsiblePersonNotEligible")}
      {t("zz_SourcingEventApiErrorCode_ChangeAlreadyInProgress")}
      {t("zz_SourcingEventApiErrorCode_ChangeDraftNotFound")}
      {t("zz_SourcingEventApiErrorCode_ChangeNotAllowedInStatus")}
      {t("zz_SourcingEventApiErrorCode_ChangeDeadlinePassed")}
      {t("zz_SourcingEventApiErrorCode_RequestPhaseStillOpen")}
      {t("zz_SourcingEventApiErrorCode_InvitationAlreadyConfirmed")}
      {t("zz_SourcingEventApiErrorCode_InvitationClosedInStatus")}
      {t("zz_SourcingEventApiErrorCode_SchemeTakesNoInvitation")}
      {t("zz_SourcingEventApiErrorCode_NoQualifiedSuppliers")}
      {t("zz_SourcingEventApiErrorCode_TenderDeadlineBelowMinimum")}
      {t("zz_SourcingEventApiErrorCode_ContractEndsByTenderDeadline")}
      {t("zz_SourcingEventApiErrorCode_EventNotAcceptingRequests")}
      {t("zz_SourcingEventApiErrorCode_ParticipationRequestAlreadySubmitted")}
      {t("zz_SourcingEventApiErrorCode_ParticipationRequestNotSubmitted")}
      {t("zz_SourcingEventApiErrorCode_AwardCriteriaMustBeExactlyOneType")}
      {t("zz_SourcingEventApiErrorCode_ParticipationRequestIncompleteSupplierInfo")}
      {t("zz_SourcingEventApiErrorCode_ParticipationRequestIncompleteExclusionGrounds")}
      {t("zz_SourcingEventApiErrorCode_ParticipationRequestIncompleteQualifications")}
      {t("zz_SourcingEventApiErrorCode_ParticipationRequestIncompleteFinalDeclaration")}
      {t("zz_SourcingEventApiErrorCode_UnresolvedParticipationRequests")}
      {t("zz_SourcingEventApiErrorCode_SelectionNotAnnounced")}
      {t("zz_SourcingEventApiErrorCode_SelectionRequired")}
      {t("zz_SourcingEventApiErrorCode_SelectionInvalid")}
      {t("zz_SourcingEventApiErrorCode_SelectionBelowMinimum")}
      {t("zz_SourcingEventApiErrorCode_SelectionAboveMaximum")}
      {t("zz_SourcingEventApiErrorCode_SelectionReasonMissing")}
      {t("zz_SourcingEventApiErrorCode_RejectionReasonMissing")}
      {t("zz_SourcingEventApiErrorCode_QualificationReviewIncomplete")}
      {t("zz_SourcingEventApiErrorCode_DpsMembershipEnded")}
      {t("zz_SourcingEventApiErrorCode_DpsVerdictAlreadySent")}
      {t("zz_SourcingEventApiErrorCode_DpsRejectionAlreadySent")}
      {t("zz_SourcingEventApiErrorCode_RejectionWithdrawalReasonMissing")}
      {t("zz_SourcingEventApiErrorCode_RejectionWithdrawalReasonTooLong")}
      {t("zz_SourcingEventApiErrorCode_QualificationEndsByRemoval")}
      {t("zz_SourcingEventApiErrorCode_DpsMembershipEndsByRemoval")}
      {t("zz_SourcingEventApiErrorCode_RejectionAlreadyWithdrawn")}
      {t("zz_SourcingEventApiErrorCode_DpsAssessmentNotExtendable")}
      {t("zz_SourcingEventApiErrorCode_DpsNotAMember")}
      {t("zz_SourcingEventApiErrorCode_DpsRequestNotOwnedByOrganization")}
      {t("zz_SourcingEventApiErrorCode_DpsRemovalReasonMissing")}
      {t("zz_SourcingEventApiErrorCode_SchemeRemovalLastDayInPast")}
      {t("zz_SourcingEventApiErrorCode_SchemeRemovalNotScheduled")}
      {t("zz_SourcingEventApiErrorCode_QualificationSchemeUnknownCategory")}
      {t("zz_SourcingEventApiErrorCode_NotInvitedToConfirmInterest")}
      {t("zz_SourcingEventApiErrorCode_NotCalledByPriorInformationNotice")}
      {t("zz_SourcingEventApiErrorCode_InterestInvitationAlreadySent")}
      {t("zz_SourcingEventApiErrorCode_NoInterestRegistered")}
      {t("zz_SourcingEventApiErrorCode_InterestInvitationOutsideNoticeWindow")}
      {t("zz_SourcingEventApiErrorCode_InterestInvitationBeforePublishedDeadline")}
      {t("zz_SourcingEventApiErrorCode_InterestRequestDeadlineTooSoon")}
      {t("zz_SourcingEventApiErrorCode_ShortRequestDeadlineNotJustified")}
      {t("zz_SourcingEventApiErrorCode_InterestRegistrationClosed")}
      {t("zz_SourcingEventApiErrorCode_JoiningClosedAtBidDeadline")}
      {t("zz_SourcingEventApiErrorCode_OwnerCannotTender")}
      {t("zz_SourcingEventApiErrorCode_JoiningClosedAsCancelled")}
      {t("zz_SourcingEventApiErrorCode_JoiningClosedAsClosed")}
      {t("zz_SourcingEventApiErrorCode_DpsSchemeNotFound")}
      {t("zz_SourcingEventApiErrorCode_DpsSchemeNotOpen")}
      {t("zz_SourcingEventApiErrorCode_DpsNotAScheme")}
      {t("zz_SourcingEventApiErrorCode_DpsNoQualifiedMembers")}
      {t("zz_SourcingEventApiErrorCode_DpsNotACompetition")}
      {t("zz_SourcingEventApiErrorCode_DpsCompetitionNotDraft")}
      {t("zz_SourcingEventApiErrorCode_DpsCompetitionAlreadyOpen")}
      {t("zz_SourcingEventApiErrorCode_DpsFirstIntakeNotClosed")}
      {t("zz_SourcingEventApiErrorCode_DpsFirstIntakeUnreviewed")}
      {t("zz_SourcingEventApiErrorCode_QualificationSchemeNotFound")}
      {t("zz_SourcingEventApiErrorCode_NotAQualificationScheme")}
      {t("zz_SourcingEventApiErrorCode_QualificationSchemeNotOpen")}
      {t("zz_SourcingEventApiErrorCode_QualificationSchemeNoAdmittedSuppliers")}
      {t("zz_SourcingEventApiErrorCode_QualificationSchemeNoChosenSupplierStillAdmitted")}
      {t("zz_SourcingEventApiErrorCode_QualificationSchemeProcedureNotAllowed")}
      {t("zz_SourcingEventApiErrorCode_QualificationSchemeSupplierNotAdmitted")}
      {t("zz_SourcingEventApiErrorCode_QualificationSchemeNarrowingNotJustified")}
      {t("zz_SourcingEventApiErrorCode_NotUnderAQualificationScheme")}
      {t("zz_SourcingEventApiErrorCode_QualificationSchemeCompetitionNotDraft")}
      {t("zz_SourcingEventApiErrorCode_QualificationSchemeBidDeadlineMissing")}
      {t("zz_SourcingEventApiErrorCode_NotNegotiationWithoutNotice")}
      {t("zz_SourcingEventApiErrorCode_NegotiationWithoutNoticeNotDraft")}
      {t("zz_SourcingEventApiErrorCode_NegotiationWithoutNoticePrecedingCompetitionNotEligible")}
      {t("zz_SourcingEventApiErrorCode_NegotiationWithoutNoticeDesignContestNotEligible")}
      {t("zz_SourcingEventApiErrorCode_NegotiationWithoutNoticeNoInvitees")}
      {t("zz_SourcingEventApiErrorCode_NegotiationWithoutNoticeInviteeNotEligible")}
      {t("zz_SourcingEventApiErrorCode_NegotiationWithoutNoticeBidDeadlineMissing")}
      {t("zz_SourcingEventApiErrorCode_ClarificationBeforeBidDeadline")}
      {t("zz_SourcingEventApiErrorCode_ClarificationWhileEntriesAnonymous")}
      {t("zz_SourcingEventApiErrorCode_NotADesignContest")}
      {t("zz_SourcingEventApiErrorCode_JuryWorkOutsideEvaluation")}
      {t("zz_SourcingEventApiErrorCode_UnknownDesignContestEntry")}
      {t("zz_SourcingEventApiErrorCode_JuryReportMissing")}
      {t("zz_SourcingEventApiErrorCode_DesignContestAwardsNoContract")}
      {t("zz_SourcingEventApiErrorCode_MiniCompetitionAwardsOneSupplier")}
      {t("zz_SourcingEventApiErrorCode_WinnerDocumentationForAnotherAward")}
      {t("zz_SourcingEventApiErrorCode_WinnerDocumentationAlreadyRecorded")}
      {t("zz_SourcingEventApiErrorCode_FrameworkCompetitionAwardsNoStandaloneContract")}
      {t("zz_SourcingEventApiErrorCode_JuryReportChanged")}
      {t("zz_SourcingEventApiErrorCode_NotThisJuryMember")}
      {t("zz_SourcingEventApiErrorCode_EntryFlagReasonRequired")}
      {t("zz_SourcingEventApiErrorCode_JuryReportNotConfirmed")}
      {t("zz_SourcingEventApiErrorCode_JuryAssessmentMissing")}
      {t("zz_SourcingEventApiErrorCode_NoFollowUpContract")}
      {t("zz_SourcingEventApiErrorCode_WinnersNotChosen")}
      {t("zz_SourcingEventApiErrorCode_FollowUpAlreadyStarted")}
      {t("zz_SourcingEventApiErrorCode_ClarificationRequiresDeliveredBid")}
      {t("zz_SourcingEventApiErrorCode_ClarificationNotAllowedInStatus")}
      {t("zz_SourcingEventApiErrorCode_ClarificationReplyDeadlinePassed")}
      {t("zz_SourcingEventApiErrorCode_DevToolsGateNotApplicable")}
      {t("zz_SourcingEventApiErrorCode_DevToolsCannotForcePublish")}
      {t("zz_SourcingEventApiErrorCode_EmailInvitesOnlyAllowedInDraftState")}
      {t("zz_SourcingEventApiErrorCode_HomeDepartmentNotInOrganization")}
      {t("zz_SourcingEventApiErrorCode_HomeDepartmentRequired")}
      {t("zz_SourcingEventApiErrorCode_CannotInviteWithoutBidDeadline")}
      {t("zz_SourcingEventApiErrorCode_InviteThroughTheOpenChange")}
      {t("zz_SourcingEventApiErrorCode_PersonToShareWithNotFound")}
      {t("zz_SourcingEventApiErrorCode_PersonToShareWithNotInOrganization")}
      {t("zz_SourcingEventApiErrorCode_CannotShareWithSelf")}
      {t("zz_SourcingEventApiErrorCode_ShareNotFound")}
      {t("zz_SourcingEventApiErrorCode_ChangeNotOpen")}
      {t("zz_SourcingEventApiErrorCode_AnnouncedTermsChangeOnlyByNotice")}
      {t("zz_SourcingEventApiErrorCode_EventValueMustNotBeNegative")}
      {t("zz_SourcingEventApiErrorCode_QualificationRemovalAfterSchemeEnds")}
      {t("zz_SourcingEventApiErrorCode_JustificationLockedAtPublishing")}
      {t("zz_SourcingEventApiErrorCode_NotVisibleInSupplierPortal")}
      {t("zz_SourcingEventApiErrorCode_PortalLinkRecipientsOutOfRange")}
      {t("zz_SourcingEventApiErrorCode_OverviewPeriodEndsBeforeItStarts")}
      {t("zz_SubscriptionApiErrorCode_EventOperationNotIncluded")}
      {t("zz_SubscriptionApiErrorCode_ContractOperationNotIncluded")}
      {t("zz_SubscriptionApiErrorCode_SignatureOperationNotIncluded")}
      {t("zz_SubscriptionApiErrorCode_AiAccessNotIncluded")}
      {t("zz_SubscriptionApiErrorCode_NeedsAccessNotIncluded")}
      {t("zz_SubscriptionApiErrorCode_ProjectsAccessNotIncluded")}
      {t("zz_UploadApiErrorCode_Unknown")}
      {t("zz_UploadApiErrorCode_MimeTypeNotSupported")}
      {t("zz_UploadApiErrorCode_InvalidSourcingEventId")}
      {t("zz_UploadApiErrorCode_InvalidNegotiationRoundId")}
      {t("zz_UploadApiErrorCode_InvalidUploadId")}
      {t("zz_UploadApiErrorCode_InvalidBidId")}
      {t("zz_UploadApiErrorCode_InvalidParticipationRequestId")}
      {t("zz_UploadApiErrorCode_InvalidQualificationCriterionKey")}
      {t("zz_UploadApiErrorCode_QualificationCriterionDoesNotRequireEvidence")}
      {t("zz_UploadApiErrorCode_InvalidAwardCriterionId")}
      {t("zz_UploadApiErrorCode_AwardCriterionDoesNotAcceptAttachments")}
      {t("zz_UploadApiErrorCode_InvalidMinimumRequirementId")}
      {t("zz_UploadApiErrorCode_MinimumRequirementDoesNotAcceptAttachments")}
      {t("zz_UploadApiErrorCode_CannotDeleteCompletedUpload")}
      {t("zz_UploadApiErrorCode_InvalidContractId")}
      {t("zz_UploadApiErrorCode_InvalidProjectId")}
      {t("zz_UploadApiErrorCode_InvalidNeedId")}
      {t("zz_UploadApiErrorCode_NeedNoLongerAcceptsAttachments")}
      {t("zz_DoffinApiErrorCode_SourcingEventNotFound")}
      {t("zz_DoffinApiErrorCode_NotPublicProcurement")}
      {t("zz_DoffinApiErrorCode_NotAnnouncedOnDoffin")}
      {t("zz_DoffinApiErrorCode_AlreadyPublished")}
      {t("zz_DoffinApiErrorCode_NoticeWaitingForDoffin")}
      {t("zz_DoffinApiErrorCode_OrganizationNotFound")}
      {t("zz_DoffinApiErrorCode_CountryNotFound")}
      {t("zz_DoffinApiErrorCode_ContactPersonNotFound")}
      {t("zz_DoffinApiErrorCode_XsdValidationFailed")}
      {t("zz_DoffinApiErrorCode_UnsupportedVariant")}
      {t("zz_DoffinApiErrorCode_DoffinSubmissionFailed")}
      {t("zz_DoffinApiErrorCode_DoffinDidNotAnswerNothingSent")}
      {t("zz_DoffinApiErrorCode_DoffinDidNotAnswerWhileSending")}
      {t("zz_DoffinApiErrorCode_DoffinAnsweredUnexpectedly")}
      {t("zz_DoffinApiErrorCode_EspdSchematronInvalid")}
      {t("zz_DoffinApiErrorCode_BuyerOrganizationNumberMissing")}
      {t("zz_DoffinApiErrorCode_BuyerCountryCodeInvalid")}
      {t("zz_DoffinApiErrorCode_NoChangeDraft")}
      {t("zz_DoffinApiErrorCode_NoPublishedNotice")}
      {t("zz_DoffinApiErrorCode_ChangeAlreadyPending")}
      {t("zz_DoffinApiErrorCode_NoConcludedAward")}
      {t("zz_DoffinApiErrorCode_ContractConclusionDateMissing")}
      {t("zz_DoffinApiErrorCode_UtilityActivityMissing")}
      {t("zz_DoffinApiErrorCode_NotCancelled")}
      {t("zz_DoffinApiErrorCode_DpsSchemeNoticeMissing")}
      {t("zz_DoffinApiErrorCode_NoWinnerNoticeForDpsPurchase")}
      {t("zz_DoffinApiErrorCode_NotAPublishedQualificationScheme")}
      {t("zz_DoffinApiErrorCode_NotWithoutCompetition")}
      {t("zz_DoffinApiErrorCode_IntentionNoticeAlreadySubmitted")}
      {t("zz_DoffinApiErrorCode_IntentionNoticeAfterContractConcluded")}
      {t("zz_DoffinApiErrorCode_CancellationNoticeAfterDeadline")}
      {t("zz_DoffinApiErrorCode_CancellationNoticeAlreadySent")}
      {t("zz_DoffinApiErrorCode_EnglishTranslationFailed")}
      {t("zz_DoffinApiErrorCode_EnglishTranslationRateLimited")}
      {t("zz_DoffinApiErrorCode_ContractModificationNotAvailable")}
      {t("zz_DoffinApiErrorCode_ModifiedContractUnknown")}
      {t("zz_DoffinApiErrorCode_ModificationExceedsHalfOfContractValue")}
      {t("zz_FrameworkAgreementApiErrorCodeFrameworkAgreementNotFound")}
      {t("zz_FrameworkAgreementApiErrorCodeRegulationFollowsItsCompetition")}
      {t("zz_FrameworkAgreementApiErrorCodeFoaPartMissing")}
      {t("zz_FrameworkAgreementApiErrorCodeNeedAlreadyStarted")}
      {t("zz_FrameworkAgreementApiErrorCodeFrameworkAgreementNotActive")}
      {t("zz_FrameworkAgreementApiErrorCodeFrameworkAgreementTermNotStarted")}
      {t("zz_FrameworkAgreementApiErrorCodeFrameworkAgreementTermEnded")}
      {t("zz_FrameworkAgreementApiErrorCodeFrameworkAgreementAlreadyTerminated")}
      {t("zz_FrameworkAgreementApiErrorCodeNotAFrameworkCompetition")}
      {t("zz_FrameworkAgreementApiErrorCodeNoAwardedBids")}
      {t("zz_FrameworkAgreementApiErrorCodeMoreWinnersThanTheFrameworkAgreementAllows")}
      {t("zz_FrameworkAgreementApiErrorCodeSupplierIsNotOnThePanel")}
      {t("zz_FrameworkAgreementApiErrorCodeSupplierIsSuspendedFromThePanel")}
      {t("zz_FrameworkAgreementApiErrorCodeSuppliersContractUnderTheFrameworkAgreementHasEnded")}
      {t("zz_FrameworkAgreementApiErrorCodeDirectAwardNotAllowed")}
      {t("zz_FrameworkAgreementApiErrorCodeCallOffExceedsTheFrameworkAgreementsMaximumValue")}
      {t("zz_FrameworkAgreementApiErrorCodeMiniCompetitionExceedsTheFrameworkAgreementsMaximumValue")}
      {t("zz_FrameworkAgreementApiErrorCodeCallOffNeedsAValueUnderTheFrameworkAgreementsMaximumValue")}
      {t("zz_FrameworkAgreementApiErrorCodeMiniCompetitionNeedsAValueUnderTheFrameworkAgreementsMaximumValue")}
      {t("zz_FrameworkAgreementApiErrorCodeMiniCompetitionsNotAllowed")}
      {t("zz_FrameworkAgreementApiErrorCodeValueNotInTheFrameworkAgreementsCurrency")}
      {t("zz_FrameworkAgreementApiErrorCodeMiniCompetitionNeedsTwoActiveSuppliers")}
      {t("zz_FrameworkAgreementApiErrorCodeMiniCompetitionNeedsTwoActiveInvitees")}
      {t("zz_FrameworkAgreementApiErrorCodeNoActiveSuppliersOnThePanel")}
      {t("zz_FrameworkAgreementApiErrorCodeRankingOutsideThePanel")}
      {t("zz_FrameworkAgreementApiErrorCodeAwardedMiniCompetitionCanOnlyBeCancelled")}
      {t("zz_FrameworkAgreementApiErrorCodePanelIsFixedByTheAward")}
      {t("zz_FrameworkAgreementApiErrorCodeSupplierIsAlreadyOnThePanel")}
      {t("zz_FrameworkAgreementApiErrorCodeSupplierIsTheBuyer")}
      {t("zz_FrameworkAgreementApiErrorCodeSupplierNotFound")}
      {t("zz_FrameworkAgreementApiErrorCodeMoreSuppliersThanTheFrameworkAgreementAllows")}
      {t("zz_MarketDialogueApiErrorCodeMarketDialogueNotFound")}
      {t("zz_MarketDialogueApiErrorCodeOnlyForPublicProcurement")}
      {t("zz_MarketDialogueApiErrorCodeNeedNotApproved")}
      {t("zz_MarketDialogueApiErrorCodeNeedAlreadyLinked")}
      {t("zz_MarketDialogueApiErrorCodeNeedNotLinkable")}
      {t("zz_MarketDialogueApiErrorCodeNotEditable")}
      {t("zz_MarketDialogueApiErrorCodeChangedElsewhere")}
      {t("zz_MarketDialogueApiErrorCodeNotDeletable")}
      {t("zz_MarketDialogueApiErrorCodeNotReady")}
      {t("zz_MarketDialogueApiErrorCodeAnswerDeadlinePassed")}
      {t("zz_MarketDialogueApiErrorCodeCannotAnswerOwnDialogue")}
      {t("zz_MarketDialogueApiErrorCodeAnswerEmpty")}
      {t("zz_MarketDialogueApiErrorCodeAnswerNotFound")}
      {t("zz_MarketDialogueApiErrorCodeAnswerTooLong")}
      {t("zz_MarketDialogueApiErrorCodeAnswerTooMuchFormatting")}
      {t("zz_MarketDialogueApiErrorCodeTooManyQuestions")}
      {t("zz_MarketDialogueApiErrorCodeQuestionTooLong")}
      {t("zz_MarketDialogueApiErrorCodeNotPublished")}
      {t("zz_MarketDialogueApiErrorCodeQuestionTakesNoDocuments")}
      {t("zz_MarketDialogueApiErrorCodeBusinessSecretWithoutReason")}
      {t("zz_MarketDialogueApiErrorCodeNotOnTeam")}
      {t("zz_MarketDialogueApiErrorCodeTeamMemberNotFound")}
      {t("zz_MarketDialogueApiErrorCodeTeamMemberNotInOrganization")}
      {t("zz_MarketDialogueApiErrorCodeNotATeamMember")}
      {t("zz_MarketDialogueApiErrorCodeCommentEmpty")}
      {t("zz_MarketDialogueApiErrorCodeCommentTooLong")}
      {t("zz_MarketDialogueApiErrorCodeInvitationsClosed")}
      {t("zz_MarketDialogueApiErrorCodeAlreadyInvited")}
      {t("zz_MarketDialogueApiErrorCodeCannotInviteOwnOrganization")}
      {t("zz_MarketDialogueApiErrorCodeInvitedOrganizationNotFound")}
      {t("zz_MarketDialogueApiErrorCodeInvitationNotFound")}
      {t("zz_MarketDialogueApiErrorCodeInvitationAlreadySent")}
      {t("zz_MarketDialogueApiErrorCodeInvalidInvitationEmail")}
      {t("zz_MarketDialogueApiErrorCodeInviteNotFound")}
      {t("zz_MarketDialogueApiErrorCodeInviteAlreadyAccepted")}
      {t("zz_MarketDialogueApiErrorCodeInviteRateLimited")}
      {t("zz_MarketDialogueApiErrorCodeInsightSummaryTooLong")}
      {t("zz_MarketDialogueApiErrorCodeProcurementNotDraft")}
      {t("zz_MarketDialogueApiErrorCodeCommentRoundAlreadyOpen")}
      {t("zz_MarketDialogueApiErrorCodeSupplierQuestionEmpty")}
      {t("zz_MarketDialogueApiErrorCodeSupplierNotInDialogue")}
      {t("zz_MarketDialogueApiErrorCodeDocumentNotInDialogue")}
      {t("zz_MarketDialogueApiErrorCodeLibraryElementNotFound")}
      {t("zz_MarketDialogueApiErrorCodeInsightReportNotAvailable")}
      {t("zz_MarketDialogueApiErrorCodeConversationClosed")}
      {t("zz_MarketDialogueApiErrorCodeSupplierQuestionTooLong")}
      {t("zz_MarketDialogueApiErrorCodeSupplierQuestionNotFound")}
      {t("zz_MarketDialogueApiErrorCodeSupplierQuestionAlreadyAnswered")}
      {t("zz_FieldErrorCode_Required")}
      {t("zz_FieldErrorCode_MustBePositive")}
      {t("zz_FieldErrorCode_OutOfRange")}
      {t("zz_FieldErrorCode_ImmutableInStatus")}
      {t("zz_FieldErrorCode_NotInThisKindOfProcurement")}
      {t("zz_FieldErrorCode_SpecialServicesTierFixedAtPublication")}
      {t("zz_FieldErrorCode_PartFixedAtPublication")}
      {t("zz_FieldErrorCode_UnknownExclusionGroundId")}
      {t("zz_FieldErrorCode_UnknownRejectionGroundId")}
      {t("zz_FieldErrorCode_RejectionGroundNotApplicableToFoaPart")}
      {t("zz_FieldErrorCode_RejectionGroundRequiresTender")}
      {t("zz_FieldErrorCode_RejectionLetterDoesNotMatchGrounds")}
      {t("zz_FieldErrorCode_RejectionLetterWrittenFromGrounds")}
      {t("zz_FieldErrorCode_RejectionGroundsExcludeEachOther")}
      {t("zz_FieldErrorCode_RejectionGroundNamedTwice")}
      {t("zz_FieldErrorCode_RejectionRequiresDisqualify")}
      {t("zz_FieldErrorCode_ExclusionGroundsAssessmentRequired")}
      {t("zz_FieldErrorCode_MissingMandatoryExclusionGround")}
      {t("zz_FieldErrorCode_DocumentNotAttached")}
      {t("zz_FieldErrorCode_MustBeExactlyDigits")}
      {t("zz_FieldErrorCode_UnknownCpvCode")}
      {t("zz_FieldErrorCode_TenderDeadlineBelowMinimum")}
      {t("zz_FieldErrorCode_TenderDeadlineNotAfterAnnouncement")}
      {t("zz_FieldErrorCode_RequestDeadlineBelowMinimum")}
      {t("zz_FieldErrorCode_ShortRequestDeadlineJustificationRequired")}
      {t("zz_FieldErrorCode_AcceleratedProcedureJustificationRequired")}
      {t("zz_FieldErrorCode_ShortBidDeadlineNotConfirmed")}
      {t("zz_FieldErrorCode_ProcedureNotSupported")}
      {t("zz_FieldErrorCode_ProcedureRequiresEeaTier")}
      {t("zz_FieldErrorCode_DpsNotAvailableInPartIi")}
      {t("zz_FieldErrorCode_OpenTenderCompetitionRequiresPartIi")}
      {t("zz_FieldErrorCode_RestrictedTenderCompetitionRequiresPartIi")}
      {t("zz_FieldErrorCode_ProcedureJustificationRequired")}
      {t("zz_FieldErrorCode_WithoutCompetitionRequiresEeaTier")}
      {t("zz_FieldErrorCode_NoCompetitionConditionRequired")}
      {t("zz_FieldErrorCode_NoCompetitionRationaleRequired")}
      {t("zz_FieldErrorCode_NoCompetitionConditionNotInRegulation")}
      {t("zz_FieldErrorCode_NoCompetitionOriginalContractRequired")}
      {t("zz_FieldErrorCode_NoCompetitionOriginalContractNotFound")}
      {t("zz_FieldErrorCode_NoCompetitionRepetitionNotForeseen")}
      {t("zz_FieldErrorCode_NoCompetitionCaseRequired")}
      {t("zz_FieldErrorCode_NoCompetitionCaseNotInRegulation")}
      {t("zz_FieldErrorCode_NegotiationWithoutNoticeRequiresEeaTier")}
      {t("zz_FieldErrorCode_DesignContestBelowPartV")}
      {t("zz_FieldErrorCode_DesignContestClimateConsiderationRequired")}
      {t("zz_FieldErrorCode_DesignContestClimateDescriptionRequired")}
      {t("zz_FieldErrorCode_DesignContestFollowUpRequired")}
      {t("zz_FieldErrorCode_DesignContestJuryCriteriaRequired")}
      {t("zz_FieldErrorCode_DesignContestJuryRequired")}
      {t("zz_FieldErrorCode_DesignContestJuryIndependenceRequired")}
      {t("zz_FieldErrorCode_DesignContestJuryQualificationShare")}
      {t("zz_FieldErrorCode_DesignContestPrizeDescriptionRequired")}
      {t("zz_FieldErrorCode_DesignContestJuryMemberNotInOrganization")}
      {t("zz_FieldErrorCode_ResponsiblePersonNotInOrganization")}
      {t("zz_FieldErrorCode_DesignContestJuryMemberCannotView")}
      {t("zz_FieldErrorCode_DesignContestJuryMemberCannotViewInDepartment")}
      {t("zz_FieldErrorCode_NegotiationWithoutNoticeCaseRequired")}
      {t("zz_FieldErrorCode_NegotiationWithoutNoticeCaseNotInRegulation")}
      {t("zz_FieldErrorCode_NegotiationWithoutNoticeRationaleRequired")}
      {t("zz_FieldErrorCode_NegotiationWithoutNoticePrecedingCompetitionRequired")}
      {t("zz_FieldErrorCode_NegotiationWithoutNoticeBasisChangeNotConfirmed")}
      {t("zz_FieldErrorCode_NegotiationWithoutNoticeInviteesRequired")}
      {t("zz_FieldErrorCode_NegotiationWithoutNoticePrecedingCompetitionNotEligible")}
      {t("zz_FieldErrorCode_NegotiationWithoutNoticeDesignContestNotEligible")}
      {t("zz_FieldErrorCode_NegotiationWithoutNoticeUnknownSupplier")}
      {t("zz_FieldErrorCode_DialoguePlanRequired")}
      {t("zz_FieldErrorCode_DialogueDescriptionRequired")}
      {t("zz_FieldErrorCode_EstimatedValueBasisRequired")}
      {t("zz_FieldErrorCode_CandidateMinimumBelowFloor")}
      {t("zz_FieldErrorCode_CandidateMinimumBelowPartIiFloor")}
      {t("zz_FieldErrorCode_CandidateMaximumBelowMinimum")}
      {t("zz_FieldErrorCode_CandidateSelectionCriteriaRequired")}
      {t("zz_FieldErrorCode_DpsUsageRequired")}
      {t("zz_FieldErrorCode_DpsValidityRequired")}
      {t("zz_FieldErrorCode_DpsValidityEndBeforeStart")}
      {t("zz_FieldErrorCode_DpsEndNotAfterFirstIntakeDeadline")}
      {t("zz_FieldErrorCode_DpsCompetitionHasNoMembers")}
      {t("zz_FieldErrorCode_DpsSchemeNotOpen")}
      {t("zz_FieldErrorCode_QualificationSchemeCompetitionHasNoInvitees")}
      {t("zz_FieldErrorCode_QualificationSchemeNotOpen")}
      {t("zz_FieldErrorCode_DpsFirstIntakeNotClosed")}
      {t("zz_FieldErrorCode_DpsFirstIntakeUnreviewed")}
      {t("zz_FieldErrorCode_QualificationSchemeValidityRequired")}
      {t("zz_FieldErrorCode_QualificationSchemeValidityEndBeforeStart")}
      {t("zz_FieldErrorCode_QualificationSchemeRulesRequired")}
      {t("zz_FieldErrorCode_ProcedureRequiresUtilitiesRegulation")}
      {t("zz_FieldErrorCode_PriorInformationCallNotOffered")}
      {t("zz_FieldErrorCode_PlannedInvitationOutsideNoticeWindow")}
      {t("zz_FieldErrorCode_EndDateBeforeStartDate")}
      {t("zz_FieldErrorCode_EndDateAfterLastSupportedDate")}
      {t("zz_FieldErrorCode_ExtensionEndsAfterLastSupportedDate")}
      {t("zz_FieldErrorCode_ExtensionDateOutsideSupportedRange")}
      {t("zz_FieldErrorCode_ExerciseDeadlineNotWithinContract")}
      {t("zz_FieldErrorCode_OptionsWithoutExtensions")}
      {t("zz_FieldErrorCode_UnknownNutsForPostCode")}
      {t("zz_FieldErrorCode_InvalidLanguageCode")}
      {t("zz_FieldErrorCode_InvalidCursor")}
      {t("zz_FieldErrorCode_InvalidFileName")}
      {t("zz_FieldErrorCode_FrameworkMaxParticipantsRequired")}
      {t("zz_FieldErrorCode_FrameworkMaximumValueRequired")}
      {t("zz_FieldErrorCode_FrameworkOverFourYearsReasonRequired")}
      {t("zz_FieldErrorCode_FrameworkOverEightYearsReasonRequired")}
      {t("zz_FieldErrorCode_FrameworkMaximumValueBelowEstimate")}
      {t("zz_FieldErrorCode_PublicationContactPhoneRequired")}
      {t("zz_FieldErrorCode_OpenEndedStartDateRequired")}
      {t("zz_FieldErrorCode_FoaPartNotPublicFlow")}
      {t("zz_FieldErrorCode_RegulationNotYetSupported")}
      {t("zz_FieldErrorCode_ContractStartNotBeforeEnd")}
      {t("zz_FieldErrorCode_ContractEndsByBidDeadline")}
      {t("zz_FieldErrorCode_ContractStartsByBidDeadline")}
      {t("zz_FieldErrorCode_CpvMismatchReservedParticipation")}
      {t("zz_FieldErrorCode_ReservedParticipationDurationTooLong")}
      {t("zz_FieldErrorCode_CpvMismatchContractNature")}
      {t("zz_FieldErrorCode_HealthSocialServicesUnderPartII")}
      {t("zz_FieldErrorCode_HealthSocialServicesUnderPartIII")}
      {t("zz_FieldErrorCode_DuplicateSelectionCriteria")}
      {t("zz_FieldErrorCode_BidSubmissionDeadlineNotPassed")}
      {t("zz_FieldErrorCode_BuyerLegalTypeTooGeneral")}
      {t("zz_FieldErrorCode_BidSubmissionDeadlineNotExtended")}
      {t("zz_FieldErrorCode_RequestDeadlineNotExtended")}
      {t("zz_FieldErrorCode_RequestDeadlineInPast")}
      {t("zz_FieldErrorCode_BidSubmissionDeadlineInPast")}
      {t("zz_FieldErrorCode_QuestionDeadlineOutsideTenderPeriod")}
      {t("zz_FieldErrorCode_DpsValidityNotExtended")}
      {t("zz_FieldErrorCode_DpsValidityInPast")}
      {t("zz_FieldErrorCode_QualificationSchemeValidityNotExtended")}
      {t("zz_FieldErrorCode_QualificationSchemeValidityInPast")}
      {t("zz_FieldErrorCode_ChangeHasNoDifferences")}
      {t("zz_FieldErrorCode_InvitingClosedAfterBidDeadline")}
      {t("zz_FieldErrorCode_EnvironmentWeightingJustificationRequired")}
      {t("zz_FieldErrorCode_EnvironmentWeightingJustificationNotAdapted")}
      {t("zz_FieldErrorCode_CriterionWeightsMustSumTo100")}
      {t("zz_FieldErrorCode_UnweightedReasonRequired")}
      {t("zz_FieldErrorCode_SubCriterionWeightsMustSumTo100")}
      {t("zz_FieldErrorCode_SubCriterionDescriptionRequired")}
      {t("zz_FieldErrorCode_DuplicatePriceCriterion")}
      {t("zz_FieldErrorCode_NotFound")}
      {t("zz_FieldErrorCode_TooLong")}
      {t("zz_FieldErrorCode_UnknownProjectTypeId")}
      {t("zz_FieldErrorCode_UnknownNeedStatus")}
      {t("zz_FieldErrorCode_NeedAlreadyTaken")}
      {t("zz_FieldErrorCode_PlannedStartInPast")}
      {t("zz_FieldErrorCode_ReplyDeadlineInPast")}
      {t("zz_FieldErrorCode_ReplyDeadlineAfterTenderValidity")}
      {t("zz_FieldErrorCode_NotEligibleResponsibleBuyer")}
      {t("zz_FieldErrorCode_DeliveryPlaceOnlyForPublicOrganizations")}
      {t("zz_FieldErrorCode_UnknownProjectStatus")}
      {t("zz_FieldErrorCode_UnknownContractTaskStatus")}
      {t("zz_FieldErrorCode_UnknownSupplierRelation")}
      {t("zz_FieldErrorCode_ProjectCannotBeOwnParent")}
      {t("zz_FieldErrorCode_PriceCriterionTakesNoDocumentation")}
      {t("zz_FieldErrorCode_WithheldFieldNotOnThisForm")}
      {t("zz_FieldErrorCode_WithheldFieldRepeated")}
      {t("zz_FieldErrorCode_WithheldFieldReleaseNotAhead")}
      {t("zz_FieldErrorCode_PriceNotInTenderCurrency")}
      {t("zz_FieldErrorCode_FileCannotBeSigned")}
      {t("zz_FieldErrorCode_ChangedSinceProposed")}
    </Box>
  );
};
